import { authSaga, regSaga, certSaga, cloakSaga, licenseSaga, groupSaga, cloakQRSaga, pushSaga, PushService } from 'cloak-file-sdk-web';

import { settingSaga } from './settingSaga'
import { upgradeSaga } from './upgradeSaga'
import { newLandingSaga } from './newLandingSaga'
import { all } from 'redux-saga/effects';

import { FIREBASE_CONFIG, FIREBASE_VAPID_KEY, PUSH_SW_PATH } from '../config'

// Web push (FCM) for license-solicitation events — inert until
// FIREBASE_CONFIG / FIREBASE_VAPID_KEY are provisioned in src/config.js.
PushService.configure({
	firebaseConfig: FIREBASE_CONFIG,
	vapidKey: FIREBASE_VAPID_KEY,
	serviceWorkerPath: PUSH_SW_PATH,
})

function* Saga() {
	yield all([regSaga(), authSaga(), certSaga(), cloakSaga(), licenseSaga(), groupSaga(), settingSaga(), upgradeSaga(), newLandingSaga(), cloakQRSaga(), pushSaga()])
}

export default Saga;
